import { CheckCircle2, Circle, Send, ShieldAlert } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export type TenderTimelineEvent = {
  id: string;
  label: string;
  status: "complete" | "current" | "blocked" | "pending";
  at?: string;
  commandName?: string;
};

export function TenderTimeline({ events }: { events: TenderTimelineEvent[] }) {
  return (
    <div className="space-y-1">
      {events.map((event) => (
        <div key={event.id} className="grid grid-cols-[24px_minmax(0,1fr)_auto] items-start gap-2 py-2 text-sm">
          <div className="mt-0.5 text-muted-foreground">{iconFor(event.status)}</div>
          <div className="min-w-0">
            <div className="truncate font-medium">{event.label}</div>
            {event.commandName ? (
              <div className="mt-0.5 truncate font-mono text-xs text-muted-foreground">{event.commandName}</div>
            ) : null}
          </div>
          <div className="flex items-center gap-2">
            {event.at ? <span className="hidden text-xs text-muted-foreground sm:inline">{event.at}</span> : null}
            <Badge variant={variantFor(event.status)}>{event.status}</Badge>
          </div>
        </div>
      ))}
    </div>
  );
}

function iconFor(status: TenderTimelineEvent["status"]) {
  if (status === "complete") return <CheckCircle2 size={16} />;
  if (status === "current") return <Send size={16} />;
  if (status === "blocked") return <ShieldAlert size={16} />;
  return <Circle size={16} />;
}

function variantFor(status: TenderTimelineEvent["status"]): "good" | "warn" | "bad" | "neutral" {
  if (status === "complete") return "good";
  if (status === "current") return "warn";
  if (status === "blocked") return "bad";
  return "neutral";
}
